import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Зээлийн жагсаалт ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Зээлдэгчийн мэдээлэл")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "card shadow" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-users fs-5 me-3",
      style: {"color":"black"}
    }),
    /*#__PURE__*/_createElementVNode("b", null, "Холбогдох этгээд")
  ])
], -1)
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "row g-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h6", null, "Холбогдох иргэний мэдээлэл", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h6", null, "Холбогдох байгууллагын мэдээлэл", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_customer_details_relation = _resolveComponent("customer-details-relation")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/loan/list' } }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_alert, {
      description: this.version,
      title: "Санамж!",
      type: "warning"
    }, null, 8, ["description"]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _hoisted_11,
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: this.customerRelationCitizen,
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              size: "mini",
              border: "",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "#",
                  width: "40px"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Нэр",
                  prop: "subjectname"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Эцгийн нэр",
                  prop: "lastname"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Монгол улсын иргэн эсэх",
                  prop: "islocal"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.islocal === "1" ? "Тийм" : "Үгүй"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Регистрийн дугаар",
                  prop: "registerno"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Холбогдож байгаа хэлбэр",
                  prop: "citizenorgrelation"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(this.citizenRelation.find(item => {
                    return scope.row.citizenorgrelation === item["itemid"];
                  })?.name1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Тухайн банк санхүүгийн байгууллагад санхүүгийн үүрэг хүлээсэн эсэх",
                  prop: "isfinancial"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.isfinancial === "1" ? "Тийм" : "Үгүй"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.dataLoadingCitizen]
            ]),
            _hoisted_12,
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              "data-bs-target": "#relationCitizenModal",
              "data-bs-toggle": "modal"
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _hoisted_15,
          _createElementVNode("div", null, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: this.customerRelationOrg,
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              size: "mini",
              border: "",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "#",
                  width: "40px"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Байгууллагын нэр",
                  prop: "subjectname"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Улсын бүртгэлийн дугаар",
                  prop: "stateregisterno"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Монгол улсад бүртгэлтэй эсэх",
                  prop: "islocal"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.islocal === "1" ? "Тийм" : "Үгүй"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Регистрийн дугаар",
                  prop: "registerno"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Холбогдож байгаа хэлбэр",
                  prop: "citizenorgrelation"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(this.orgRelation.find(item => {
                    return scope.row.citizenorgrelation === item["itemid"];
                  })?.name1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Тухайн банк санхүүгийн байгууллагад санхүүгийн үүрэг хүлээсэн эсэх",
                  prop: "isfinancial"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.isfinancial === "1" ? "Тийм" : "Үгүй"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.dataLoadingOrg]
            ]),
            _hoisted_16,
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              "data-bs-target": "#relationOrgModal",
              "data-bs-toggle": "modal"
            }, {
              default: _withCtx(() => [
                _hoisted_17,
                _hoisted_18
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_19
      ])
    ]),
    _createVNode(_component_customer_details_relation, {
      onReloadLoanDetails: this.getLoanDetails,
      citizenRelation: this.citizenRelation,
      orgRelation: this.orgRelation,
      loancode: this.loancode,
      customercode: this.customercode
    }, null, 8, ["onReloadLoanDetails", "citizenRelation", "orgRelation", "loancode", "customercode"])
  ], 64))
}